import React, { useState } from 'react';
import { Grid, IconButton, Avatar } from '@material-ui/core';
import { Description } from '@material-ui/icons';
import { useSelector } from 'react-redux';
import { sessionsAPI } from 'src/api/modules/sessions';
import notice from 'src/common/components/Notice';
import MigratedFiles from '../MigratedFiles/MigratedFiles';
import AdditionalFiles from './AdditionalFiles';
import './styles/_btnGuia.scss';

const Documents = ({ session }) => {
	const { user } = useSelector((state) => state.auth);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const [importedFiles, setImportedFiles] = useState(false);
	const [addFilesModal, setAddFilesModal] = useState(false);
	const [loadingDOCX, setLoadingDOCX] = useState(false);
	const [loadingPDF, setLoadingPDF] = useState(false);
	const tipoXOrgano = session.organoColegiado?.prefijo === 'AG' ? '2' : '1';
	const usersCanDownGuia = [
		'ADMINISTRADOR GENERAL',
		'SISTEMA',
		'RESPONSABLE DE ORGANO COLEGIADO',
		'RESPONSABLE DE NEGOCIO',
		'RESPONSABLE DE SEGUIMIENTO',
	];

	const generateGuieDOCX = () => {
		setLoadingDOCX(true);

		sessionsAPI
			.generateGuie(session.id, tipoXOrgano, 2)
			.then((response) => {
				let blob = response;

				const linkSource =
					'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,' +
					blob;
				const downloadLink = document.createElement('a');
				downloadLink.href = linkSource;
				downloadLink.download = 'Guia.docx';
				downloadLink.click();

				setLoadingDOCX(false);
				notice('Descarga de guía completa', 'success');
			})
			.catch(() => {
				notice('Ocurrió un error al descargar guía');
				setLoadingDOCX(false);
			});
	};

	const generateGuiePDF = () => {
		setLoadingPDF(true);

		sessionsAPI
			.generateGuie(session.id, tipoXOrgano, 1)
			.then((response) => {
				let blob = response;
				const linkSource = 'data:application/pdf;base64,' + blob;
				const downloadLink = document.createElement('a');
				downloadLink.href = linkSource;
				downloadLink.download = 'Guia';
				downloadLink.click();
				setLoadingPDF(false);
				notice('Descarga de guía completa', 'success');
			})
			.catch(() => {
				notice('Ocurrió un error al descargar guía');
				setLoadingPDF(false);
			});
	};

	return (
		<div
			className="card"
			style={{
				height: '75%',
				padding: '5px 0px 0px 0px',
			}}
		>
			<Grid container>
				<Grid item md={1} lg={2}></Grid>
				{session.migrado === true && (
					<Grid item xs={3}>
						<IconButton
							onClick={() => {
								setImportedFiles(true);
							}}
						>
							<Avatar
								style={{
									backgroundColor: '#cbe5fb',
									color: '#0080F9',
									height: '120px',
									width: '120px',
								}}
							>
								<Grid container>
									<Grid item xs={12}>
										Archivos Migrados
									</Grid>
									<Grid item xs={12}>
										<Description
											style={{
												height: '30px',
												width: '30px',
											}}
										/>
									</Grid>
								</Grid>
							</Avatar>
						</IconButton>
					</Grid>
				)}
				{usersCanDownGuia.includes(systemLevelRole) &&
					session.publicada === 'P' && (
						<Grid item xs={3}>
							<div
								className="container"
								style={{
									position: 'relative',
									fontSize: '17px',
									color: '#0080F9',
									top: '10%',
								}}
							>
								<button
									className="semi-circulo-left"
									disabled={loadingDOCX}
									onClick={() => {
										generateGuieDOCX(session.id, '1', '1');
									}}
								></button>

								<button
									className="semi-circulo-right"
									disabled={loadingPDF}
									onClick={() => {
										generateGuiePDF(session.id, '1', '1');
									}}
								></button>
								<p
									style={{
										position: 'absolute',
										top: '15%',
										left: '40px',
									}}
								>
									Descargar
								</p>
								<p
									style={{
										position: 'absolute',
										top: '30%',
										left: '60px',
									}}
								>
									Guía
								</p>

								<p
									style={{
										position: 'absolute',
										top: '55%',
										left: '30px',
									}}
								>
									{loadingDOCX && (
										<span className="ml-2 spinner spinner-white"></span>
									)}
									Word
								</p>
								<p
									style={{
										position: 'absolute',
										top: '55%',
										left: '100px',
									}}
								>
									{loadingPDF && (
										<span className="spinner spinner-white"></span>
									)}
									PDF
								</p>
								<Description
									style={{
										position: 'absolute',
										height: '20px',
										width: '20px',
										top: '75%',
										left: '74px',
									}}
								/>
							</div>
						</Grid>
					)}
				<Grid item xs={3}>
					<IconButton
						onClick={() => {
							setAddFilesModal(true);
						}}
					>
						<Avatar
							style={{
								backgroundColor: '#cbe5fb',
								color: '#0080F9',
								height: '120px',
								width: '120px',
							}}
						>
							{/* dictamenes */}
							<Grid container>
								<Grid item xs={12}>
									Archivos Adicionales
								</Grid>
								<Grid item xs={12}>
									<Description
										style={{
											height: '30px',
											width: '30px',
										}}
									/>
								</Grid>
							</Grid>
						</Avatar>
					</IconButton>
				</Grid>
			</Grid>
			<MigratedFiles
				open={importedFiles}
				setOpen={setImportedFiles}
				idSession={session.id}
			/>
			<AdditionalFiles
				open={addFilesModal}
				setClose={() => {
					setAddFilesModal(false);
				}}
				dataSession={session}
				user={user}
			/>
		</div>
	);
};

export default Documents;
